import request from '@/axios'

export function courseListing (customer_id, payload, queryParams = 1) {
  return request({
    url:`/course/list/${customer_id}?page=${queryParams}`,
    method:'POST',
    data:payload
  })
}

export function createGradeRule (payload) {
  return request({
    url:'/grade/create-rule',
    method:'POST',
    data:payload
  })
}

export function getGradeRule (course_id) {
  return request({
    url:`/grade/get-rule/${course_id}`,
    method:'GET'
  })
}

export function updateGradeRule (course_id, payload) {
  return request({
    url:`/grade/update-rule/${course_id}`,
    method:'POST',
    data:payload
  })
}

export function resetGradeRule (course_id) {
  return request({
    url:`/grade/reset-rule/${course_id}`,
    method:'GET'
  })
}

export function studentAnswers (customer_id, payload) {
  return request({
    url:`course/student-answers/${customer_id}`,
    method:'POST',
    data: payload
  })
}

export function studentAnswersDetails (customer_id, answer_list_id) {
  return request({
    url:`course/student-answer-detail/${customer_id}/${answer_list_id}`,
    method:'POST'
  })
}

export function studentAnswersRemark (customer_id, payload) {
  return request({
    url:`course/student-answers-remark/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function studentGradebook (payload) {
  return request({
    url:'ClientUser/course/gradebook',
    method:'POST',
    data:payload
  })
}


export function gradebookUpdate (customer_id, payload) {
  return request({
    url:`/course/student/gradebook-update/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function studentAnswersRemarkReport (customer_id, payload) {
  return request({
    url:`/course/student-answers-remark-report/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function gradebook_download (payload) {
  return request({
    url:'/ClientUser/course/gradebook/download/pdf',
    method:'POST',
    data:payload
  })
}